import { defineMessages } from 'react-intl';

type MessageKeys = 'errorTitle' | 'errorDescription' | 'retryButton';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		errorTitle: {
			id: 'rovo-growth-pulse.insights-feed.error.title',
			defaultMessage: 'Something went wrong',
			description:
				'Heading displayed on the error screen when insights fail to load in the Rovo Insights panel.',
		},
		errorDescription: {
			id: 'rovo-growth-pulse.insights-feed.error.description',
			defaultMessage: 'We couldn\u2019t load your insights. Check your connection and try again.',
			description: 'Explanatory text displayed below the error heading when insights fail to load.',
		},
		retryButton: {
			id: 'rovo-growth-pulse.insights-feed.error.retry-button',
			defaultMessage: 'Try again',
			description:
				'Label for the retry button on the error screen that allows users to re-attempt loading insights.',
		},
	});

export default message;
